<template>
  <transition :name="transitionName">
    <div class="dropdown" v-if="lazyValue">
      <div class="dropdown__content" ref="content">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "AppDropdown",
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false,
    },
    transitionName: {
      type: String,
      required: false,
      default: "slide-left",
    },
  },
  methods: {
    onClick(e) {
      if (!this.canClose) {
        this.canClose = true;
        return;
      }

      if (this.$el.contains(e.target)) {
        return;
      }

      this.lazyValue = !this.lazyValue;
      this.$emit("input", this.lazyValue);
    },
  },
  watch: {
    value: {
      handler(value) {
        this.lazyValue = value;
        this.$nextTick(() => {
          if (value) {
            document.body.addEventListener("click", this.onClick);
            return;
          }

          this.canClose = false;
          document.body.removeEventListener("click", this.onClick);
        });
      },
      immediate: true,
    },
  },
  data() {
    return {
      lazyValue: this.value,
      canClose: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.dropdown {
  background-color: $white;
  padding-block: 24px;
  position: fixed;
  height: 100%;
  color: $black;
  z-index: 99;
  width: 96%;
  right: 0;
  top: 0;

  @include media-breakpoint-up(md) {
    padding-block: 48px;
    width: 484px;
  }

  .dropdown__content {
    height: 100%;
    width: 100%;
    overflow: auto;
    text-align: left;
  }
  &.main-header__profile-dropdown--logged-in {
    @include media-breakpoint-up(md) {
      top: 2.75rem !important;
      overflow-y: initial;
      position: absolute;
      padding-block: 0;
      width: 18.125rem;
      right: -3.75rem;
      height: auto;
      bottom: auto;
      &:before {
        content: "";
        position: absolute;
        top: -5px;
        width: 10px;
        height: 10px;
        background-color: #fff;
        -webkit-transform: rotate(45deg);
        transform: rotate(45deg);
        margin-left: -10px;
        bottom: 100%;
        right: 60px;
        border: solid transparent;
        border-width: 7px 9px;
        border-bottom-color: #f8f8f8;
        display: block;
      }
    }
  }
}
</style>
